import React, { useState } from "react";
import "./BillingPage.css";

const BillingPage = () => {
  const today = new Date().toLocaleDateString();
  const autoBillNo = `BILL-${Date.now()}`;

  const [clinicName, setClinicName] = useState("HerbArtz Ayurveda");
  const [patientName, setPatientName] = useState("");
  const [discount, setDiscount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState("Cash");

  // Multiple items
  const [items, setItems] = useState([
    { name: "", qty: 1, price: 0 }
  ]);

  // Item handlers
  const handleItemChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;
    setItems(updatedItems);
  };

  const addItem = () => {
    setItems([...items, { name: "", qty: 1, price: 0 }]);
  };

  const removeItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  // Calculations
  const subtotal = items.reduce(
    (sum, item) => sum + item.qty * item.price,
    0
  );

  const discountAmount = (subtotal * discount) / 100;
  const grandTotal = subtotal - discountAmount;

  return (
    <div className="billing-container">
      {/* LEFT – FORM */}
      <div className="billing-form no-print">
        <h2>Billing</h2>

        <label>Clinic Name</label>
        <input value={clinicName} onChange={(e) => setClinicName(e.target.value)} />

        <label>Patient Name</label>
        <input value={patientName} onChange={(e) => setPatientName(e.target.value)} />

        <h4>Treatments / Products</h4>

        {items.map((item, index) => (
          <div className="item-row" key={index}>
            <input
              placeholder="Treatment / Product"
              value={item.name}
              onChange={(e) => handleItemChange(index, "name", e.target.value)}
            />
          <h4>Qty</h4>
            <input
              type="number"
              min="1"
              placeholder="Qty"
              value={item.qty}
              onChange={(e) => handleItemChange(index, "qty", Number(e.target.value))}
            />
           <h4>Price</h4>
            <input
              type="number"
              min="0"
              placeholder="Price"
              value={item.price}
              onChange={(e) => handleItemChange(index, "price", Number(e.target.value))}
            />

            {items.length > 1 && (
              <button className="remove-btn" onClick={() => removeItem(index)}>
                ✕
              </button>
            )}
          </div>
        ))}

        <button className="add-btn" onClick={addItem}>+ Add Item</button>

        <label>Discount (%)</label>
        <input
          type="number"
          min="0"
          value={discount}
          onChange={(e) => setDiscount(Number(e.target.value))}
        />

        <label>Payment Method</label>
        <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
          <option>Cash</option>
          <option>Card</option>
          <option>Online</option>
        </select>

        <button onClick={() => window.print()}>Print Bill</button>
      </div>

      {/* RIGHT – PREVIEW */}
      <div className="bill-preview">
        <h1>{clinicName}</h1>
        <p className="small">Ayurvedic Treatment & Wellness</p>

        <hr />

        <div className="bill-meta">
          <span><strong>Bill No:</strong> {autoBillNo}</span>
          <span><strong>Date:</strong> {today}</span>
        </div>

        <p><strong>Patient:</strong> {patientName}</p>

        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, i) => (
              <tr key={i}>
                <td>{item.name}</td>
                <td>{item.qty}</td>
                <td>{item.price.toFixed(2)}</td>
                <td>{(item.qty * item.price).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="totals">
          <div>Subtotal: {subtotal.toFixed(2)}</div>
          <div>Discount: {discountAmount.toFixed(2)}</div>
          <div className="grand">Grand Total: {grandTotal.toFixed(2)}</div>
        </div>

        <p className="payment">Payment Method: {paymentMethod}</p>
        <p className="thanks">Thank you. Be well 🌿</p>
      </div>
    </div>
  );
};

export default BillingPage;